@if (model) {
    <div class="phx-formly-padded mb-2">
        <label
            class="font-bold"
            *ngIf="this.model?.documentDefinition?.documentDirection === DocumentDirectionType.IN"
            [attr.data-testid]="'formly-document-postal-address-widget-label-1'"
            >{{ 'document.vendor' | translate }}</label
        >
        <label
            class="font-bold"
            *ngIf="this.model?.documentDefinition?.documentDirection === DocumentDirectionType.OUT"
            [attr.data-testid]="'formly-document-postal-address-widget-label-2'"
        >
            {{ 'document.customer' | translate }}
        </label>
        <label
            *ngIf="!this.model?.documentDefinition?.documentDirection"
            [attr.data-testid]="'formly-document-postal-address-widget-label-3'"
        >
            {{ 'document.address' | translate }}
        </label>

        <!-- Address DropDown Component -->
        <!-- right now all address dropdowns are blocked if address is blocked for one thing in the document -->
        <app-address-drop-down
            #addressDropDown
            class="font-bold"
            [disabled]="
                model.status === DocumentStatusType.CO || model.status === DocumentStatusType.RE
            "
            [value]="model?.address"
            [placeholder]="'document.addresses' | translate"
            (valueChange)="selectedAddressChanged($event)"
            [showInfoPopup]="true"
            [autoOpenOnNew]="
                !model?.id &&
                !this.options.formState?.detailComponent.loading() &&
                !this.options.formState?.detailComponent.noAutoOpenOnNew()
            "
            [showOnlyCreditors]="this.showCreditor()"
            [showOnlyDebitors]="this.showDebitor()"
            [allowForProspects]="model?.documentDefinition?.allowForProspects"
            [documentDirection]="model?.documentDefinition?.documentDirection"
            [deliveryRelevant]="model?.documentDefinition?.deliveryRelevant"
            [autoloadItems]="false"
            [externalDataTestId]="true"
            [dataTestId]="'formly-document-postal-address-widget-address-drop-down'"
        />
    </div>
}

<!-- Postal Address Form -->
<form
    *ngIf="postalAddressForm"
    [formGroup]="postalAddressForm"
    [disableForm]="{
        state: model.status === DocumentStatusType.CO || model.status === DocumentStatusType.RE,
        form: postalAddressForm
    }"
>
    <formly-form
        [model]="formControl.value"
        [fields]="fallbackFields"
        [form]="postalAddressForm"
        [options]="options"
    >
    </formly-form>
</form>
